export const normalizeMemberId = (id?: string | null) => {
  if (!id) return '';
  return id.replace(/^OrganizationMember:/, '');
};

export const toPrefixedMemberId = (id?: string | null) => {
  if (!id) return '';
  return id.startsWith('OrganizationMember:') ? id : `OrganizationMember:${id}`;
};
